import ProjectApi from './rest/ProjectApi';

export default new ProjectApi();
